/**
 * Canonical codes for payment file row failures (API, processors, UI).
 */
export const PAYMENT_FILE_ROW_FAILURE_CODE = {
    SUPPLIER_NOT_FOUND: 'SUPPLIER_NOT_FOUND',
    SUPPLIER_NOT_APPROVED: 'SUPPLIER_NOT_APPROVED',
};
/**
 * User-facing copy for scoped supplier row failures (payment file modal, API, processors).
 * Keep in sync with payment file supplier validation: one clear reason per code.
 */
export const PAYMENT_FILE_ROW_FAILURE_DISPLAY_MESSAGE = {
    [PAYMENT_FILE_ROW_FAILURE_CODE.SUPPLIER_NOT_FOUND]: 'This supplier could not be found. Add the supplier or correct the vendor or supplier ID.',
    [PAYMENT_FILE_ROW_FAILURE_CODE.SUPPLIER_NOT_APPROVED]: 'This supplier is not approved for payment processing. Complete supplier approval before retrying.',
};
const GENERIC_ROW_FAILURE = 'This row could not be processed.';
/**
 * Resolves the message to show for a failed row: known codes use shared copy; otherwise first error or generic.
 */
export function getPaymentFileRowFailureDisplayMessage(result) {
    if (result.status !== 'failed')
        return '';
    const code = result.failure_code;
    if (code) {
        const label = PAYMENT_FILE_ROW_FAILURE_DISPLAY_MESSAGE[code];
        if (label !== undefined)
            return label;
    }
    return result.errors?.[0] ?? GENERIC_ROW_FAILURE;
}
/**
 * Canonical codes for a BAI2 parse failure. The retryable set sits beside them
 * so callers read it instead of restating which failure is worth another attempt.
 * `BAI2_PARSER_UNREACHABLE` is the set's only member.
 */
export const BAI2_PARSE_ERROR_CODE = {
    INVALID_CONTENT: 'BAI2_INVALID_CONTENT',
    PARSER_FAILED: 'BAI2_PARSER_FAILED',
    PARSER_UNREACHABLE: 'BAI2_PARSER_UNREACHABLE',
};
export const BAI2_PARSE_RETRYABLE_ERROR_CODES = new Set([
    BAI2_PARSE_ERROR_CODE.PARSER_UNREACHABLE,
]);
export function isBai2ParseErrorCode(value) {
    return Object.values(BAI2_PARSE_ERROR_CODE).includes(value);
}
export function isBai2ParseErrorRetryable(code) {
    return BAI2_PARSE_RETRYABLE_ERROR_CODES.has(code);
}
//# sourceMappingURL=file-processing.js.map